// extracted by mini-css-extract-plugin
export default {"whatsAppButton":"OrderButton_whatsAppButton__dwa3h"};